import { useEffect, useState } from 'react';
import { is768Query } from '~/core/scripts/mediaquery-helper';

const isSmallScreen = !is768Query();

export default () => {
  const [activeItemId, setActiveItemId] = useState(null);

  useEffect(() => {
    const items = document.querySelectorAll('.item');
    const checkPoint = isSmallScreen ? window.innerHeight * .6 : window.innerHeight / 2;

    const onScroll = () => {
      const closestToCheckpoint = [].reduce.call(items, (res, item) => {
          const bounds = item.getBoundingClientRect();
          const itemTop = bounds.top + (bounds.height / 2);
          const distance = Math.abs(checkPoint - itemTop);

          if (distance < res.distance) {
            res.distance = distance;
            res.id = item.getAttribute('data-id');
          }

          return res;
        }, { distance: Number.MAX_VALUE, id: null });

      setActiveItemId(closestToCheckpoint.id);
    }

    window.onscroll = onScroll;
    onScroll();

    return () => {
      window.onscroll = null;
    };
  }, []);

  return activeItemId;
};